import { useState } from 'react';
import { StyledContainerContent } from '../components/ContainerContent';
import { StyledLayoutBody } from '../components/LayoutBody';
import { LayoutRow } from '../components/LayoutRow';
import { StyledLayoutTable } from '../components/LayoutTable';
import { SearchInput } from '../components/SearchInput';

const ServeIndex = () => {
	const [searchText, setSearchText] = useState('');

	return (
		/* @ts-ignore */
		globalLayoutList && (
			<StyledLayoutBody>
				<StyledContainerContent>
					<SearchInput placeholder={'Поиск'} onChange={setSearchText} />
					<StyledLayoutTable>
						{
							/* @ts-ignore */
							globalLayoutList
								.filter((name: string) =>
									name.toLowerCase().includes(searchText.toLowerCase()),
								)
								.map((name: string, index: number) => (
									<LayoutRow key={`layout#${index}`} name={name} />
								))
						}
					</StyledLayoutTable>
				</StyledContainerContent>
				{/* <StyledContainerContent>
					<WebpConverter />
				</StyledContainerContent> */}
			</StyledLayoutBody>
		)
	);
};

export default ServeIndex;
